import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

import makeAnimated from "react-select/animated";
import SidePanel from "./SidePanel.jsx";
import DeletePopup from "../../elements/DeletePopup";
import { ReactComponent as LinkIcon } from "../../assets/icons/Link.svg";
import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/AddPlus.svg";
import { ReactComponent as ExportIcon } from "../../assets/icons/download.svg";
import { ReactComponent as CirclePlus } from "../../assets/icons/circlePlus.svg";
import { ReactComponent as AddEditor } from "../../assets/icons/addEditor.svg";
import { ReactComponent as AddTable } from "../../assets/icons/addTable.svg";
import libcss from "../../css/library.module.css";
import MenuIcon from "../../assets/icons/Menu.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  createDisclosureApiHandler,
  createSubDisclosureApiHandler,
  updateDisclosureApiHandler,
  getTemplateDetailsApiHandler,
  updateSubDisclosureApiHandler,
  deleteDisclosureApiHandler,
  deleteSubDisclosureApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/editPri.svg";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as DelIcon } from "../../../myfin_v2/assets/icons/delete_red.svg";
import TemplateTableGenerator from "./TemplateTableGenerator";
import QuillReactEditor from "../../components/QuillReactEditor";


import CustomTable from "../../../Console/Component/CustomTable/CustomTable";

const genId = () => Math.random().toString(36).slice(2);

const normalizeFromInitial = (initialDoc) => {
  const items = [];
  (initialDoc?.data || []).forEach((block) => {
    if (block.dataType === "text") {
      items.push({
        id: genId(),
        type: "text",
        dataType: "text",
        textFormat: "html",
        textRaw: block?.textRaw ?? " ",
        textPlain: block?.textPlain ?? " ",
        text: [
          {
            id: genId(),
            content: block?.textRaw ?? " ",
          },
        ],
      });
    } else if (block.dataType === "table") {
      items.push({
        id: genId(),
        _id: block._id,
        type: "table",
        tableTitle: block.tableTitle || "Untitled Table",
        tableRow: Array.isArray(block.tableRow)
          ? block.tableRow.map((r) => ({ ...r }))
          : [],
        tableColumn: Array.isArray(block.tableColumn)
          ? block.tableColumn.map((c) => ({ ...c }))
          : [],
        tableType: block?.tableType ?? "table",
        table: block?.table ?? null,
        hasCellData: block?.tableType === "content",
      });
    }
  });
  return items;
};

// Serialize the flat list back to your exact schema
const serialize = (name, items) => {
  const data = items.map((it) => {
    if (it.type === "text") {
      return {
        dataType: "text",
        textFormat: it.textFormat,
        textRaw: it?.textRaw ?? " ",
        textPlain: it?.textPlain ?? " ",
      };
    }
    if (it.type === "table") {
      const hasCellData =
        it.hasCellData !== undefined
          ? it.hasCellData
          : (it.tableType === "content" || (Array.isArray(it.table) && it.table.length > 0));

      const tableObj = {
        dataType: "table",
        tableTitle: it.tableTitle || "Untitled Table",
       tableRow: (it.tableRow || []).map((row) => ({
  name: row.name || "",
  lineType: row.lineType || "line item",

  ...(row._id && { _id: row._id }),

  ...(row.formulaType && {
    formulaType: row.formulaType,
  }),

  ...(row.isBold !== undefined && {
    isBold: row.isBold,
  }),

  ...(row.lineType === "formula" && {
    formula: row.formula || [],
  }),
})),
        tableColumn: (it.tableColumn || []).map((col) => ({
          name: col.name || "",
          lineType: col.lineType || "line item",
          ...(col._id && { _id: col._id }),
          ...(col.lineType === "formula" && { formula: col.formula || [] }),
        })),
      };

      if (hasCellData) {
        tableObj.tableType = "content";
        tableObj.table = it.tableData || it.table || [];
      }

      return tableObj;
    }
    return it;
  });

  return { name, data };
};

const removeIdsAndFormulas = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => removeIdsAndFormulas(item));
  }

  if (typeof obj === "object" && obj !== null) {
    const newObj = {};

    Object.keys(obj).forEach((key) => {
      if (key === "_id" || key === "formula") {
        return;
      }

      newObj[key] = removeIdsAndFormulas(obj[key]);
    });

    return newObj;
  }

  return obj;
};

export default function Disclosures({
  tempId,
  setHandleSave,
  handleSave,
  isReadOnly = false,
}) {
  // ── Note inline-edit state ─────────────────────────────────────────────────
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  // ── Sub-note inline-edit state (single declaration) ───────────────────────
  const [isSubEditing, setIsSubEditing] = useState(false);
  const [editingSubId, setEditingSubId] = useState(null);
  const [editingSubValue, setEditingSubValue] = useState("");
  const [editingParentId, setEditingParentId] = useState(null);

  // ── Side panel state ───────────────────────────────────────────────────────
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [selectedCell, setSelectedCell] = useState(null);

 const DISCLOSURE_LINK_COL_NAMES = ["cy", "py", "current year", "previous year", "currentyear", "previousyear"];
const DISCLOSURE_COL_API_MAP = {
  "cy": "currentYear",
  "py": "previousYear",
  "current year": "currentYear",
  "previous year": "previousYear",
  "currentyear": "currentYear",
  "previousyear": "previousYear",
};

const handleCellLinkClick = (row, col, dataID, tableItem) => {
  if (row === 0) return;
  if (col === 0) return;  // ← first column is always row-label, never linkable

  // try to get column name from tableColumn
  const colName = String(
    tableItem?.tableColumn?.[col]?.name ?? ""
  ).toLowerCase().trim();

  let resolvedCol = null;

  if (colName) {
    const matchedKey = DISCLOSURE_LINK_COL_NAMES.find((n) => colName.includes(n));
    if (!matchedKey) return;
    resolvedCol = DISCLOSURE_COL_API_MAP[matchedKey];
  } else {
    // tableColumn unavailable (cell-data mode table) — use col index
    // col 1 = currentYear, col 2 = previousYear by convention
    if (col === 1) resolvedCol = "currentYear";
    else if (col === 2) resolvedCol = "previousYear";
    else return;
  }

  const rowName = String(tableItem?.tableRow?.[row - 1]?.name ?? row);

  const cellKey = `${dataID}-${row}-${col}`;
  setActiveCellKey(cellKey);
  setSelectedCell({ row: rowName, col: resolvedCol });
  setSelectedDataID(dataID);
  setIsSidePanelOpen(true);
};
  // Add after existing state declarations
  const [linkedCells, setLinkedCells] = useState({});
  const [activeCellKey, setActiveCellKey] = useState(null);
  const [isAddingTable, setIsAddingTable] = useState(false);
  // ── Editor / items state ───────────────────────────────────────────────────
  const [name, setName] = useState("");
  const [items, setItems] = useState(() => normalizeFromInitial(null));
  const [output, setOutput] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);

  // ── Note list / composer state ─────────────────────────────────────────────
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const animatedComponents = makeAnimated();
  let history = useHistory();
  const dispatch = useDispatch();
  const [libraryName, setLibraryName] = useState("ST Library");
  const [activeItem, setActiveItem] = useState(null);
  const [selNote, setSelNote] = useState(null);
  const [selNoteId, setSelNoteId] = useState(null);
  const [selParentId, setSelParentId] = useState(null);
  const [notes, setNotes] = useState(null);
  const [note, setNote] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [showPanel, setShowPanel] = useState(false);
  const [activeCell, setActiveCell] = useState(null);
  const [selectedDataID, setSelectedDataID] = useState(null);

  const openPanel = (row, col) => {
    setActiveCell({ row, col });
    setShowPanel(true);
  };

  const [isComposing, setIsComposing] = useState(false);
  const [noteName, setNoteName] = useState("");
  const inputRef = useRef(null);

  const [templateData, setTemplateData] = useState(null);

  // ── API calls ──────────────────────────────────────────────────────────────
  const getTemplateDetails = (updatedTemplate) => {
    if (updatedTemplate && updatedTemplate.disclosure) {
      setTemplateData(updatedTemplate);
      return;
    }
    getTemplateDetailsApiHandler({ groupingTemplateID: tempId })
      .then((response) => {
        if (response?.data?.success === true) {
          setTemplateData(response?.data?.groupingTemplate);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getTemplateDetails();
  }, []);

  useEffect(() => {
    getTemplateDetails();
  }, [activeItem]);

  useEffect(() => {
    if (notes && notes.length > 0 && !selNote) {
      const firstNote = notes[0];
      setItems(normalizeFromInitial(firstNote));
      setActiveItem(`gs_0`);
      setSelNote("general");
      setSelNoteId(firstNote._id);
      setSelParentId(null);
      setOutput(firstNote);
      setName(firstNote.name);
    }
  }, [notes, selNote]);



  // ── Editor helpers ─────────────────────────────────────────────────────────
  const handleAddParagraph = () => {
    setItems((prev) => [
      ...prev,
      {
        id: genId(),
        type: "text",
        text: [{ id: genId(), content: "" }],
        textFormat: "html",
        textRaw: " ",
        textPlain: " ",
      },
    ]);
  };

  const handleAddTable = () => {
    setIsAddingTable(true);
  };

  const removeItem = (id) => {
    const target = items.find((it) => it.id === id);
    if (!target) return;

    if (!templateData?._id || !selNoteId) {
      swal("Error", "Template data not loaded yet", "error");
      return;
    }

    setDeleteConfirm({
      title: "Are you sure?",
      message: "This item will be deleted permanently",
      onConfirm: () => {
        setDeleteConfirm(null);
        const filteredItems = items.filter((it) => it.id !== id);
        const payload = removeIdsAndFormulas(serialize(name, filteredItems));

        const apiCall =
          selNote === "general_sn"
            ? updateSubDisclosureApiHandler(
                {
                  groupingTemplateID: templateData._id,
                  disclosureID: selParentId,
                  subNoteID: selNoteId,
                },
                payload
              )
            : updateDisclosureApiHandler(
                { groupingTemplateID: templateData._id, disclosureID: selNoteId },
                payload
              );

        apiCall
          .then((response) => {
            if (response?.data?.success === true) {
              setItems(filteredItems);
              swal("Successfully deleted", "", "success");
              getTemplateDetails();
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to delete the item",
                "error"
              );
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error ||
                error?.message ||
                "Unable to delete the item",
              "error"
            );
          });
      }
    });
  };

  const updateEditorContent = (id, html) => {
    setItems((prev) =>
      prev.map((it) =>
        it.id === id
          ? {
              ...it,
              text: [{ id: it.text?.[0]?.id ?? genId(), content: html }],
              textFormat: "html",
              textRaw: html?.html ?? " ",
              textPlain: html?.text ?? " ",
            }
          : it
      )
    );
  };

  const updateTableItem = (id, patch) => {
    setItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, ...patch } : it))
    );
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
    setItems(newItems);
  };

  useEffect(() => {
    setOutput(serialize(name, items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, items]);

  // ── Note composer ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (isComposing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isComposing]);

  const handleAddClick = () => {
    setIsComposing(true);
    setNoteName("");
  };

  const handleCancel = () => {
    setIsComposing(false);
    setNoteName("");
  };

  const handlePost = () => {
    const value = String(noteName || "").trim();
    if (!value) return;
    setNote([value, ...note]);
    setNoteName("");
    setIsComposing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (isEditing) {
        if (!editingId) return;
        addNotes();
      } else {
        handlePost();
      }
    }
    if (e.key === "Escape") handleCancel();
  };

  // ── Sub-note composer ──────────────────────────────────────────────────────
  const [subComposeFor, setSubComposeFor] = useState(null);
  const [subNoteName, setSubNoteName] = useState("");
  const subInputRef = useRef(null);

  useEffect(() => {
    if (subComposeFor !== null && subInputRef.current) {
      subInputRef.current.focus();
    }
  }, [subComposeFor]);

  const openSubComposer = (noteIndex) => {
    setSubComposeFor(noteIndex);
    setSubNoteName("");
  };

  const cancelSubComposer = () => {
    setSubComposeFor(null);
    setSubNoteName("");
  };

  const postSubnote = () => {
    const value = subNoteName.trim();
    if (!value || subComposeFor === null) return;
    setNotes((prev) => {
      const next = [...prev];
      const target = { ...next[subComposeFor] };
      const subNotes = Array.isArray(target.subNotes)
        ? [...target.subNotes]
        : [];
      subNotes.push({ name: value });
      target.subNotes = subNotes;
      next[subComposeFor] = target;
      return next;
    });
    setSubNoteName("");
    setSubComposeFor(null);
  };

  const addSub = (note_id) => {
    const value = subNoteName.trim();
    if (!value) return;

    const payload = { name: subNoteName };

    if (isSubEditing) {
      updateSubDisclosureApiHandler(
        {
          groupingTemplateID: tempId,
          disclosureID: editingParentId,
          subNoteID: editingSubId,
        },
        payload
      ).then(() => {
        setIsSubEditing(false);
        setEditingSubId(null);
        setEditingParentId(null);
        setSubNoteName("");
        setSubComposeFor(null);
        getTemplateDetails();
      });
    } else {
      createSubDisclosureApiHandler(
        { groupingTemplateID: tempId, disclosureID: note_id },
        payload
      ).then((response) => {
        if (response?.data?.success) {
          setSubNoteName("");
          setSubComposeFor(null);
          setNotes(response?.data?.updatedGroupingTemplate?.disclosure);
        }
      });
    }
  };

  const handleSubKeyDown = (e) => {
    if (e.key === "Enter") {
      if (isSubEditing) {
        addSub(editingParentId);
      } else {
        postSubnote();
      }
    }
    if (e.key === "Escape") cancelSubComposer();
  };

  // ── Save handler ───────────────────────────────────────────────────────────
  useEffect(() => {
    if (handleSave !== "disclosures") return;

    if (!selNoteId) {
      console.log("❌ selNoteId missing");
      return;
    }

    const payload = removeIdsAndFormulas(output);

    if (selNote === "general_sn") {
      updateSubDisclosureApiHandler(
        {
          groupingTemplateID: templateData._id,
          disclosureID: selParentId,
          subNoteID: selNoteId,
        },
        payload
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Saved successfully ", "", "success");
            getTemplateDetails();
          } else {
            swal("Error", "Unable to save data", "error");
          }
        })
        .catch(() => {
          swal("Error", "Something went wrong", "error");
        });
    } else {
      updateDisclosureApiHandler(
        {
          groupingTemplateID: templateData._id,
          disclosureID: selNoteId,
        },
        payload
      )
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Saved successfully", "", "success");
            getTemplateDetails();
          } else {
            swal("Error", "Unable to save data", "error");
          }
        })
        .catch(() => {
          swal("Error", "Something went wrong", "error");
        });
    }

    setHandleSave(null);
  }, [handleSave]);

  useEffect(() => {
    setNotes(templateData?.disclosure);
  }, [templateData]);

  useEffect(() => {
  if (!templateData?.disclosure) return;
  const map = {};
  templateData.disclosure.forEach((note) => {
    const allNotes = [note, ...(note.subNotes || [])];
    allNotes.forEach((n) => {
      (n.data || []).forEach((block) => {
        if (block.dataType !== "table") return;
        (block.cellFormulas || []).forEach((f) => {
          const cellKey = `${block._id}-${f.row}-${f.col}`;
          map[cellKey] = f;
        });
      });
    });
  });
  setLinkedCells(map);
}, [templateData]);

  // ── Add / update note ──────────────────────────────────────────────────────
  const addNotes = () => {
    const value = String(noteName || "").trim();
    if (!value) return;

    const payload = { name: noteName };

    if (isEditing) {
      updateDisclosureApiHandler(
        { groupingTemplateID: tempId, disclosureID: editingId },
        payload
      ).then(() => {
        setIsEditing(false);
        setEditingId(null);
        setNoteName("");
        setIsComposing(false);
        getTemplateDetails();
      });
    } else {
      createDisclosureApiHandler({ groupingTemplateID: tempId }, payload).then(
        (response) => {
          setNoteName("");
          setIsComposing(false);
          setNotes(response?.data?.updatedGroupingTemplate?.disclosure);
        }
      );
    }
  };

  const resetItems = () => {
    setItems(normalizeFromInitial(null));
    setActiveItem(null);
    setSelNote(null);
    setSelNoteId(null);
    setSelParentId(null);
  };

  // ── Delete handlers ────────────────────────────────────────────────────────
  const deleteNoteHandler = (id) => {
    setDeleteConfirm({
      title: "Confirm deletion of disclosure data?",
      message: "Once deleted, you will not be able to recover this!",
      onConfirm: () => {
        setDeleteConfirm(null);
        deleteDisclosureApiHandler({
          groupingTemplateID: tempId,
          disclosureID: id,
        })
          .then((response) => {
            if (response?.data?.success === true) {
              resetItems();
              getTemplateDetails();
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to delete the data",
              "error"
            );
          });
      }
    });
  };

  const deleteSubNoteHandler = (id, subid) => {
    setDeleteConfirm({
      title: "Confirm deletion of disclosure data?",
      message: "Once deleted, you will not be able to recover this!",
      onConfirm: () => {
        setDeleteConfirm(null);
        deleteSubDisclosureApiHandler({
          groupingTemplateID: tempId,
          disclosureID: id,
          subNoteID: subid,
        })
          .then((response) => {
            if (response?.data?.success === true) {
              resetItems();
              getTemplateDetails();
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to delete the data",
              "error"
            );
          });
      }
    });
  };

  // ── Inline update handlers ─────────────────────────────────────────────────
  const handleUpdateNote = (id, value) => {
    if (!String(value || "").trim()) return;

    updateDisclosureApiHandler(
      { groupingTemplateID: tempId, disclosureID: id },
      { name: value }
    )
      .then((res) => {
        if (res?.data?.success) {
          getTemplateDetails();
          setEditingNoteId(null);
        }
      })
      .catch(() => {});
  };

  const handleUpdateSubNote = (parentId, subId, value) => {
    if (!String(value || "").trim()) return;

    updateSubDisclosureApiHandler(
      {
        groupingTemplateID: tempId,
        disclosureID: parentId,
        subNoteID: subId,
      },
      { name: value }
    )
      .then((res) => {
        if (res?.data?.success) {
          getTemplateDetails();
          setEditingSubId(null);
        }
      })
      .catch(() => {});
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
        <motion.div
          initial={{ x: 500, y: 500, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1 }}
          exit={{ x: 0, y: 0, opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          className={libcss.hierarchyLayout}
          style={{ border: "0px", marginTop: "0px", gap: "5px", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px", width: "100%", maxWidth: "100%", height: "calc(100% - 50px)", boxSizing: "border-box" }}
        >
          {/* ── Left panel: notes list ──────────────────────────────────────── */}
          <div
            className={`${libcss.notesSec} ${commoncss.hideScroll}`}
            style={{ width: "40%", height: "100%" }}
          >
            <div className={libcss.levelCatDiv} style={{ marginTop: "0px", gap: "10px", height: "100%", boxSizing: "border-box" }}>
              <div className={libcss.levelCat} style={{ height: "100%", display: "flex", flexDirection: "column", boxSizing: "border-box" }}>
                <span className={libcss.notesLabel}>
                  <span>Disclosures</span>
                  {!isReadOnly && (
                    <span
                      className={libcss.addNoteLabel}
                      onClick={handleAddClick}
                      style={{ cursor: "pointer" }}
                    >
                      <PlusIcon /> Add
                    </span>
                  )}
                </span>

                <div className={`${libcss.levelCatDiv} ${libcss.notesDiv2}`} style={{ flex: 1, height: "auto", overflowY: "auto" }}>
                  {isComposing && !isReadOnly && (
                    <div className={libcss.notesItem}>
                      <input
                        ref={inputRef}
                        value={noteName}
                        onChange={(e) => setNoteName(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Type your note..."
                        className={libcss.noteInput}
                      />
                      <div className={libcss.lineActions1}>
                        <span
                          className={`${commoncss.clickable}`}
                          onClick={addNotes}
                          disabled={!noteName.trim()}
                        >
                          Add
                        </span>
                        &ensp;
                        <CloseIcon
                          onClick={handleCancel}
                          width={14}
                          height={14}
                        />
                      </div>
                    </div>
                  )}

                  {notes &&
                    notes.map((noteItem, i) => (
                      <div key={`note-${noteItem._id || i}`}>
                        <div
                          className={
                            hoveredIndex === i || activeItem === `gs_${i}`
                              ? libcss.notesItem
                              : libcss.notesItemView
                          }
                          onMouseEnter={() => setHoveredIndex(i)}
                          onMouseLeave={() => setHoveredIndex(null)}
                          onClick={() => {
                            setItems(normalizeFromInitial(noteItem));
                            setActiveItem(`gs_${i}`);
                            setSelNote("general");
                            setSelNoteId(noteItem._id);
                            setSelParentId(null);
                            setOutput(noteItem);
                            setName(noteItem.name);
                          }}
                        >
                          {editingNoteId === noteItem._id ? (
                            <input
                              value={editingValue}
                              autoFocus
                              onChange={(e) => setEditingValue(e.target.value)}
                              onBlur={() =>
                                handleUpdateNote(noteItem._id, editingValue)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter")
                                  handleUpdateNote(noteItem._id, editingValue);
                                if (e.key === "Escape")
                                  setEditingNoteId(null);
                              }}
                              className={libcss.noteInput}
                            />
                          ) : (
                            noteItem.name
                          )}

                          {(hoveredIndex === i || activeItem === `gs_${i}`) &&
                            !isReadOnly && (
                              <div className={libcss.lineActions1}>
                                <PlusIcon
                                  role="button"
                                  tabIndex={0}
                                  onClick={() => openSubComposer(i)}
                                  onKeyDown={(e) =>
                                    (e.key === "Enter" || e.key === " ") &&
                                    openSubComposer(i)
                                  }
                                />
                                &ensp;
                                <EditIcon
                                  width={15}
                                  height={15}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEditingNoteId(noteItem._id);
                                    setEditingValue(noteItem.name);
                                  }}
                                />
                                &ensp;
                                <CloseIcon
                                  className={commoncss.clickable}
                                  width={16}
                                  height={16}
                                  onClick={() =>
                                    deleteNoteHandler(noteItem._id)
                                  }
                                />
                              </div>
                            )}
                        </div>

                        {subComposeFor === i && !isReadOnly && (
                          <div className={libcss.subNotesItemView}>
                            <input
                              ref={subInputRef}
                              value={subNoteName}
                              onChange={(e) => setSubNoteName(e.target.value)}
                              onKeyDown={handleSubKeyDown}
                              placeholder="Type subnote…"
                              className={libcss.noteInput}
                            />
                            <div className={libcss.lineActions1}>
                              <span
                                className={`${commoncss.clickable}`}
                                onClick={() => addSub(noteItem._id)}
                                disabled={!subNoteName.trim()}
                              >
                                Add
                              </span>
                              &ensp;
                              <CloseIcon
                                onClick={cancelSubComposer}
                                width={14}
                                height={14}
                              />
                            </div>
                          </div>
                        )}

                        {noteItem?.subNotes?.length > 0 &&
                          noteItem.subNotes.map((subnote, j) => {
                            const subActiveKey = `gs_sn_${i}-${j}`;
                            const subHoverKey = `s-${i}-${j}`;
                            const isActiveOrHover =
                              hoveredIndex === subHoverKey ||
                              activeItem === subActiveKey;

                            return (
                              <div
                                key={`sub-${subnote._id || `${i}-${j}`}`}
                                className={
                                  isActiveOrHover
                                    ? libcss.notesItem
                                    : libcss.subNotesItemView
                                }
                                onMouseEnter={() =>
                                  setHoveredIndex(subHoverKey)
                                }
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={() => {
                                  setItems(normalizeFromInitial(subnote));
                                  setActiveItem(subActiveKey);
                                  setSelNote("general_sn");
                                  setSelNoteId(subnote._id);
                                  setSelParentId(noteItem._id);
                                  setOutput(subnote);
                                  setName(subnote.name);
                                }}
                              >
                                {editingSubId === subnote._id ? (
                                  <input
                                    value={editingSubValue}
                                    autoFocus
                                    onChange={(e) =>
                                      setEditingSubValue(e.target.value)
                                    }
                                    onBlur={() =>
                                      handleUpdateSubNote(
                                        noteItem._id,
                                        subnote._id,
                                        editingSubValue
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter")
                                        handleUpdateSubNote(
                                          noteItem._id,
                                          subnote._id,
                                          editingSubValue
                                        );
                                      if (e.key === "Escape")
                                        setEditingSubId(null);
                                    }}
                                    className={libcss.noteInput}
                                  />
                                ) : (
                                  subnote.name
                                )}

                                {isActiveOrHover && !isReadOnly && (
                                  <div className={libcss.lineActions1}>
                                    <EditIcon
                                      width={15}
                                      height={15}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEditingSubId(subnote._id);
                                        setEditingSubValue(subnote.name);
                                      }}
                                    />
                                    &ensp;
                                    <CloseIcon
                                      className={commoncss.clickable}
                                      width={16}
                                      height={16}
                                      onClick={() =>
                                        deleteSubNoteHandler(
                                          noteItem._id,
                                          subnote._id
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          {/* ── Right panel: editor ─────────────────────────────────────────── */}
         <div
          className={libcss.dataDivs}
          style={{
            border: "none",
            padding: "0",
            marginTop: "0px",
            height: "97.5%",
            overflow: "hidden",
          }}
        >
          <div
              className={libcss.levelCatDiv}
              style={{
                paddingLeft: 0,
                paddingRight: 0,
                background: "#ffffff",
                border: "1px solid #e3efe7",
                borderRadius: "14px",
                padding: "16px",

                height: "100%",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <DragDropContext onDragEnd={onDragEndItems}>
                <Droppable droppableId="disclosure-items">
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={{ display: "grid", gap: 20 }}
                    >
                      {items.map((it, idx) => (
                        <Draggable key={it.id} draggableId={it.id} index={idx} isDragDisabled={isReadOnly}>
                          {(dragProvided) => (
                            <div
                              ref={dragProvided.innerRef}
                              {...dragProvided.draggableProps}
                              style={{
                                ...dragProvided.draggableProps.style,
                                width: "100%",
                                minWidth: "100%",
                              }}
                            >
                            {/* Content Area */}
                            {it.type === "text" ? (
                              <QuillReactEditor
                                value={it.text?.[0]?.content ?? " "}
                                onChange={(content) => {
                                  updateEditorContent(it.id, content);
                                }}
                                disabled={isReadOnly}
                                dragHandleProps={dragProvided.dragHandleProps}
                                rightControl={
                                  !isReadOnly && (
                                    <DelIcon
                                      style={{ cursor: "pointer", width: 16, height: 16, marginRight: 8 }}
                                      onClick={() => removeItem(it.id)}
                                    />
                                  )
                                }
                              />
                            ) : (
                              <div
                                style={{
                                  border: "1px solid #e3efe7",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  background: "#fff",
                                  width: "100%",
                                }}
                              >
                                {/* Unified Header - Only for tables */}
                                <div
                                  style={{
                                    background: "#f8f9f9",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #e3efe7",
                                    gap: "12px",
                                  }}
                                >
                                  <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                    <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                  </div>
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "13px",
                                      color: "#205a46",
                                      textTransform: "uppercase",
                                      flex: 1,
                                    }}
                                  >
                                    {it.tableTitle || "Table"}
                                  </span>
                                  {!isReadOnly && (
                                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                      <EditIcon
                                        style={{ cursor: "pointer", width: 16, height: 16 }}
                                        onClick={() => setForceOpenTableId(it.id)}
                                      />
                                      <DelIcon
                                        style={{ cursor: "pointer", width: 16, height: 16 }}
                                        onClick={() => removeItem(it.id)}
                                      />
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{
                                    background: "#fff",
                                    padding: 0,
                                  }}
                                >
                                  <TemplateTableGenerator
                                    isDisclosureTable={true}
                                    linkedCells={linkedCells}
                                    tableId={it._id || it.id}
                                    onCellLinkClick={(row, col) =>
                                      handleCellLinkClick(row, col, it._id, it)
                                    }
                                    forceOpen={it.id === forceOpenTableId}
                                    value={{
                                      tableTitle: it.tableTitle,
                                      tableRow: it.tableRow,
                                      tableColumn: it.tableColumn,
                                      tableType: it.tableType,
                                      table: it.table,
                                      hasCellData: it.hasCellData,
                                    }}
                                    onChange={(next) => {
                                      updateTableItem(it.id, {
                                        tableTitle: next.tableTitle,
                                        tableRow: next.tableRow,
                                        tableColumn: next.tableColumn,
                                        hasCellData: next.hasCellData,
                                        tableData: next.tableData,
                                        tableType: next.tableType,
                                        table: next.table,
                                      });
                                    }}
                                    onAfterOpen={() => {
                                      if (forceOpenTableId === it.id)
                                        setForceOpenTableId(null);
                                    }}
                                    disabled={isReadOnly}
                                    hideHeader={true}
                                    allowReorder={true}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              {selNote && !isReadOnly && (
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    padding: 12,
                    borderRadius: 12,
                    marginBottom: 12,
                  }}
                >
                  <CirclePlus width={37} />
                  <AddEditor width={140} onClick={handleAddParagraph} />
                  <AddTable width={100} onClick={handleAddTable} />
                </div>
              )}

              {isAddingTable && (
                <TemplateTableGenerator
                  isDisclosureTable={true}
                  forceOpen={true}
                  value={{}}
                  onChange={(next) => {
                    const id = genId();
                    setItems((prev) => [
                      ...prev,
                      {
                        id,
                        type: "table",
                        tableTitle: next.tableTitle,
                        tableRow: next.tableRow,
                        tableColumn: next.tableColumn,
                        hasCellData: next.hasCellData,
                        tableData: next.tableData,
                        tableType: "",
                        table: [],
                      },
                    ]);
                    setIsAddingTable(false);
                  }}
                  onCancel={() => setIsAddingTable(false)}
                />
              )}
            </div>
          </div>
        </motion.div>
      {isSidePanelOpen && (
        <SidePanel
          type="disclosure"
          tempId={tempId}
          isTemplate={true}
          groupingTemplateID={tempId}
          activeCellKey={activeCellKey}
          showLinkPanel={isSidePanelOpen}
          setShowLinkPanel={(val) => {
            setIsSidePanelOpen(val);
            if (!val) setSelectedCell(null);
          }}
          selectedCell={selectedCell}
          disclosureID={selNoteId}
          dataID={selectedDataID}
          table={(() => {
            if (!templateData?.disclosure || !selectedDataID) return null;
            const allNotes = templateData.disclosure.flatMap((n) => [
              n,
              ...(n.subNotes || []),
            ]);
            const matchedNote = allNotes.find((n) => n._id === selNoteId);
            return (matchedNote?.data || []).find((b) => b._id === selectedDataID) || null;
          })()}
          onApply={(data, updatedTemplate) => {
            setLinkedCells((prev) => {
              const updated = { ...prev };
              if (!data) {
                delete updated[activeCellKey];
              } else {
                updated[activeCellKey] = data;
              }
              return updated;
            });
            if (updatedTemplate) {
              setTemplateData(updatedTemplate);
            } else {
              getTemplateDetails();
            }
          }}
          onSaveSuccess={getTemplateDetails}
        />
      )}
      <DeletePopup
        isOpen={deleteConfirm !== null}
        title={deleteConfirm?.title}
        message={deleteConfirm?.message}
        onConfirm={deleteConfirm?.onConfirm}
        onCancel={() => setDeleteConfirm(null)}
      />
      </>
  );
}
